import { CSSProgressiveBody03 } from "@caisy/league";
import styled from "styled-components";

export const SOnboardingTemplatesTemplateDescription = styled.div`
  ${CSSProgressiveBody03};
  color: var(--text-04);
`;
